import React, { useEffect } from "react";
import { Store } from '../../store';


import { ProductFilter } from '../ProductFilter';
// import { ProductChart } from '../ProductChart';
// import { ProductListCompare } from './ProductListCompare';
// import { ProductItem } from '../ProductItem';
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone
} from "react-bootstrap-table2-paginator";


import Button from "react-bootstrap/Button";
import BootstrapTable from "react-bootstrap-table-next";

import {
  toggleCompareAction,
  toggleDetailAction,
  toggleFavAction,
  changePageAction,
  toggleLoading,
  fetchAllData
} from "../../actions";

import "./Products.scss";
import { Container, Row, Col } from "react-bootstrap";
import { StarsRating } from '../StarsRating/StarsRating';
import { ICompare } from '../../interfaces/index';

export interface ProductsProps {

}
 
export function Products({}: ProductsProps) {
  const { state, dispatch }: any = React.useContext(Store);
  

  useEffect(() => {
    fetchAllData(state, dispatch);
    setTimeout(() => {
      toggleLoading(false, dispatch);
    }, 1500);
  }, [
    state.filterCurrentPage,
    state.filterCategories,
    state.filterSubCategories,
    state.filterParams,
    state.searchPattern
  ]);

  // useEffect(() => {
  //   fetchDataSubCategories(state, dispatch);
  // }, [state.loaded, state.filterSubCategories, state.filterCategories]);

  const totalSize = state.tableTotal.value;
  const data = state.tableResults.length !== 0 ? state.tableResults : [];
  const page = state.filterCurrentPage;
  const sizePerPage = state.filterSize;
  const favorites = state.favs.length !== 0 ? state.favs : [];


  const columns = [
    {
      dataField: "_source",
      text: "Libellé",
      sort: false,
      classes: "col-sm-5 pl-4",
      formatter: rankFormatter,
      headerClasses: "col-sm-5 pl-4 justify-content-start"
    },
    {
      dataField: "_source.rating",
      text: "Notation<br/>Morning Star",
      formatter: starsFormatter,
      headerFormatter: sortHeaderFormatter,
      headerClasses: "d-none d-md-table-cell text-center",
      classes: "d-none d-md-table-cell",
      sort: false
    },
    {
      dataField: "_source.purchase_charge_front_load_fee",
      text: "Frais<br/>d'entrée",
      formatter: feeFormatter,
      headerFormatter: sortHeaderFormatter,
      headerClasses: "d-none d-md-table-cell text-center",
      classes: "d-none d-md-table-cell text-center",
      sort: false
    },
    {
      dataField: "_source.performance_end_of_month_1_year",
      text: "Performance<br/>sur 1 an",
      headerFormatter: sortHeaderFormatter,
      formatter: perfFormatter,
      hidden: state.showCol1Yperf,
      headerClasses: "d-none d-md-table-cell text-center",
      classes: "d-none d-md-table-cell text-center",
      sort: false
    },
    {
      dataField: "_source.performance_end_of_month_3_years",
      text: "Performance<br/>sur 3 ans",
      headerFormatter: sortHeaderFormatter,
      formatter: perfFormatter,
      hidden: state.showCol3Yperf,
      headerClasses: "d-none d-md-table-cell text-center",
      classes: "d-none d-md-table-cell text-center",
      sort: false
    }
  ];

  const selectRow = {
    mode: "checkbox",
    clickToSelect: false,
    selectColumnPosition: "right",
    hideSelectAll: true,
    onSelect: handleOnSelect,
    selected: state.favs.map((a: any) => a._id),
    selectionRenderer: ({ mode, ...rest }: any) => {
      const { rowIndex, ...rest_of_rest } = rest;
      return (
        <div className="custom-control custom-checkbox">
          <input
            type={mode}
            {...rest_of_rest}
            className="custom-control-input"
            onChange={() => {}}
          />
          <label className="custom-control-label"> </label>
        </div>
      );
    }
  };

  const defaultSorted = [
    {
      dataField: "_source.name",
      order: "desc"
    }
  ];

  function perfFormatter(cell: any) {
    let classFormat: string = "";
    let number: number = cell ? cell : 0;
    if (cell !== null || cell !== 0) {
      if (Math.sign(number) === 0 || Math.sign(number) === -1) {
        classFormat = `text-danger`;
      } else {
        classFormat = `text-primary`;
      }

      const isPositive = number !== 0 ? number.toFixed(2) : 0;
      return <span className={classFormat}>{isPositive}%</span>;
    }
    return <span className="text-danger">{number}%</span>;
  }

  function feeFormatter(cell: any) {
    let classFormat: string = "";
    let number: number = cell ? cell : 0;
    if (cell !== null || cell !== 0) {
      if (Math.sign(number) === 0 || Math.sign(number) === -1) {
        classFormat = `text-primary`;
      } else {
        classFormat = `text-primary`;
      }

      const isPositive = number !== 0 ? number.toFixed(2) : 0;
      return <span className={classFormat}>{isPositive}%</span>;
    }
    return <span className="text-primary">{number}%</span>;
  }

  function starsFormatter(cell: any) {
    return <StarsRating stars={cell}></StarsRating>;
  }

  function rankFormatter(cell: any, row: any) {
    return (
      <span>
        <button className="detailFond" onClick={() => onClickDetailFund(row)}>
          <span>{cell.provider}</span>
          <br />
          <strong>{cell.name}</strong>
        </button>
      </span>
    );
  }

  function sortHeaderFormatter(column: any) {
    return (
      <span>
        <span dangerouslySetInnerHTML={{ __html: column.text }} />
      </span>
    );
  }

  function onClickDetailFund(row: ICompare) {
    toggleDetailAction(true, row, dispatch);
  }

  function handleOnSelect(row: ICompare, isSelect: boolean) {
    if (isSelect) {
      if (state.favs.length < 3) {
        toggleFavAction(row, state, dispatch);
      } else {
        return false;
      }
    } else {
      toggleFavAction(row, state, dispatch);
    }
  }

  function handleOnCompare() {
    toggleCompareAction(state.dataCompare, dispatch);
  }

  function handleTableChange(type: string, { page }: any) {
    changePageAction(page, dispatch);
    toggleLoading(true, dispatch);
  }


  return (
    <Container className={`dataData container-fluid ${!state.dataCompare && !state.detail_page.show ? 'd-block' : 'd-none'}`}>
      <Row className="container-product-list flex-xl-nowrap">
        <Col xs={12} md={4}>
          <Row className="row-listing sticky-top">
            <Col xs={12} className="">
              <ProductFilter />
            </Col>
          </Row>
        </Col>
        <Col xs={12} md={8}>
          <Row className="container-table">
            <Col>
              <PaginationProvider
                pagination={paginationFactory({
                  custom: true,
                  page,
                  sizePerPage,
                  totalSize
                })}
              >
                {({ paginationProps, paginationTableProps }: any) => (
                  <Row>
                    <Col xs="12">
                      {state.loading === true && (
                        <div className="tableLoading">
                          <div className="spinner-grow" role="status">
                            <span className="sr-only">Chargement...</span>
                          </div>
                        </div>
                      )}
                      <div className="tableData">
                        <div className="products-display">
                          <Row className="d-sm-flex justify-content-sm-between align-items-sm-center">
                            <Col xs="12" lg="4" className="text-primary">
                              {Object.keys(state.tableTotal).length !== 0 &&
                                state.tableTotal.relation === "gte" && (
                                  <span>
                                    Plus de {state.tableTotal.value} fonds
                                    correspondent à vos critères
                                  </span>
                                )}
                              {Object.keys(state.tableTotal).length !== 0 &&
                                state.tableTotal.relation !== "gte" && (
                                  <span>
                                    {state.tableTotal.value} fonds
                                    correspondent à vos critères
                                  </span>
                                )}
                              {Object.keys(state.tableTotal).length ===
                                0 && (
                                <span>
                                  Aucun fond correspond à vos critères
                                </span>
                              )}
                            </Col>
                            <Col xs="12" lg="8">
                              <div className="d-md-flex justify-content-center justify-content-md-between justify-content-lg-end align-items-sm-center">
                                {
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                }

                                <div className="text-right container-btn-action d-flex justify-content-between justify-content-md-between align-items-center ml-md-4">
                                  <Button
                                    variant="primary"
                                    disabled={favorites.length === 0}
                                    onClick={() => handleOnCompare()}
                                  >
                                    Comparer
                                  </Button>
                                </div>
                              </div>
                            </Col>
                          </Row>
                        </div>
                        <Row>
                          <Col xs="12">
                            <div className="container-bootstrap-table">
                              <BootstrapTable
                                bootstrap4
                                remote={{
                                  pagination: true,
                                  filter: false,
                                  sort: false
                                }}
                                classes="table-listing"
                                keyField="_id"
                                data={data}
                                loading={state.loading}
                                columns={columns}
                                selectRow={selectRow}
                                defaultSorted={defaultSorted}
                                onTableChange={handleTableChange}
                                noDataIndication="Aucun fond correspond à vos choix de critère."
                                {...paginationTableProps}
                                striped
                                hover
                                bordered={false}
                              />
                            </div>
                          </Col>
                          <Col
                            xs="12"
                            className="text-right ml-3 mr-3 pb-4"
                          >
                            <div className="d-flex justify-content-sm-end align-items-sm-center">
                              <PaginationListStandalone
                                {...paginationProps}
                              />
                            </div>
                          </Col>
                        </Row>

                        {/* {data && data.length !== 0 && (
                        <div
                          className={`mt-2 ${isGraphActive ? "" : "d-none"}`}
                        >
                          <ProductChart
                            data={data}
                            changeData={loading}
                          ></ProductChart>
                        </div>
                      )} */}
                      </div>
                    </Col>
                  </Row>
                )}
              </PaginationProvider>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>

  );
};
